import { IBuilding } from '../building';
import { ISuite } from './suite';

export interface IPetType {
    id: number;
    name: string;
}

export interface IPet {
    id?: number;
    breed: string;
    building: number|IBuilding;
    dateOfBirth: string;
    height: string;
    weight: string;
    name: string;
    note: string;
    petType: number|IPetType;
    suite: number|ISuite;
}

export class Pet implements IPet {
    id = null;
    breed = '';
    building = null;
    dateOfBirth = '';
    height = '';
    weight = '';
    name = '';
    note = '';
    petType = null;
    suite = null;

    constructor(pet: Partial<IPet> = {}) {
        Object.assign(this, pet);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/pet.ts